module.exports = __webpack_public_path__ + "img/Bitciontalk.6040f9a9.png";